import React, { useEffect, useState, useRef } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";

const SecurityObjectName = 'Website.Client';

const ClientComponent = (props) => {

    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [contentData, setContentData] = useState("");
   
    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [clients, setClients] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [clientId, setclientId] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [bannerImage, setBannerImage] = useState(null);
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);
    const [accordianStatus, setAccordianStatus] = useState('0');


    const onSubmit = async (data, event) => {
        //Sandeep: File object and fileId need to be deleted if not uploaded.
        setLoaderApi(true);
        if (data.file && data.file[0] !== undefined && data.file[0].name !== null) {
            await HttpHelper.post("Location/UploadFileAsync", { 'Folder': 'Client', 'File': data.file[0] }, {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                }
            }).then((response) => {
                data.FileId = response.data[0].fileId;
                delete data.file;
                if (isEditing === true) {
                    clientUpdate(data)
                }
                else {
                    clientAdd(data)
                }
            });
        }
        else {
            delete data.file;
            if (isEditing === true) {
                clientUpdate(data, clientId)
            }
            else {
                clientAdd(data)
            }
        }
    }

    const clientAdd = async (data) => {
        delete data.clientId;
        await HttpHelper.post("Client", data).then((response) => {
            props.showToast('success', 'Client Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetClientList();
        }).catch((error) => {
            deleteUploadedFile(data.FileId)
            console.log(error);
        })
    }

    const clientUpdate = async (data, clientId) => {
        await HttpHelper.put("Client", data).then((response) => {
            props.showToast('success', 'Client Added Succesfully');
            blankFormData();
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetClientList();

        })
    }

    const deleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Location/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const GetClientList = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Client").then((response) => {
            if (response.status == 200) {
                setClients(response.data.data);
                getAllPermission();
                setIsEditing(true);
                setLoaderApi(false);
            } else {
                console.info(response.data.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const setClientById = async (clientId) => {
        setPopupAddEdit(true);
        setLoaderApi(true);
        setIsEditing(true);
        setShowLoader(true);
        await HttpHelper.get("Client/" + clientId).then((response) => {
            if (response.status === 200) {

                setValue('name', response.data.name);
                setValue('description', response.data.description);
                if (response.data.file) {
                    setBannerImage(response.data.file.fileUrl);
                } else {
                    setBannerImage(null);
                }
                setContentData(response.data.description);
                setValue("clientId", response.data.clientId);
                setValue("fileId", response.data.fileId);
                setValue("rowVersion", response.data.rowVersion);
            }
            setShowLoader(false);
            setPopupAddEdit(true);
            setLoaderApi(false);
        }).catch((error) => {
            setShowLoader(false)
            console.log(error);
        })
    }

    const deleteClient = async (clientId, fileId) => {
        swal("Are you sure, you want to delete this client?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("Client/" + clientId).then((response) => {
                        if (response.status === 200) {
                            GetClientList();
                        }
                        if (fileId) {
                            deleteUploadedFile(fileId)
                        }
                        props.showToast('success', 'Client Deleted successfully');
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            });
    }

    const blankFormData = () => {
        setIsEditing(false)
        setValue('file', null);
        setValue('fileId', null);
        setValue('clientId', '');
        setValue('name', '');
        setValue('description', '');
        setContentData('');
    }

    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    useEffect(() => {
        GetClientList();
    }, []);

    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Clients" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasAddPermissionUser == true ? <div className="col-auto">
                                {isEditing === true ? <button onClick={() => {
                                    setPopupAddEdit(true);
                                    blankFormData();
                                    accordianStatusHandle('1');
                                }} className="btn btnSave">Add Client</button> : ''}
                            </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>
                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Client Name
                                                </th>
                                                <th>
                                                    Description
                                                </th>
                                                <th>
                                                    Image
                                                </th>
                                                <th>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                //Sandeep: Client Grid.
                                                clients.length > 0 ? clients.map((client, index) => {
                                                    return (<tr key={index}>
                                                        <td style={{ verticalAlign: 'center' }}>{client.name}</td>
                                                        <td style={{ verticalAlign: 'center' }}>{client.description.replace(/(<([^>]+)>)/ig, '')}</td>
                                                        <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                            {
                                                                client.file && client.file.fileUrl ? < img src={client.file.fileUrl} width="30" height="30" /> : null
                                                            }
                                                        </td>
                                                        <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                            {hasEditPermissionUser == true ? <CiEdit onClick={() => { setClientById(client.clientId) }} /> : ''}
                                                            {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {deleteClient(client.clientId)}} /> : ''}
                                                        </td>
                                                    </tr>)
                                                })
                                                    : <tr><td colSpan="5">No data found!!!</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>}
                        </div>
                    </div>
                    <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                        <div className="crossPopup" onClick={() => {
                            setShowImgPopup(false);
                            setImageCurrentShow('');
                        }}>
                            <RxCross1 />
                        </div>
                        <img src={imageCurrentShow} />
                    </div>
                </div>
                {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                            :
                            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                                <div className="cardBox">
                                    <h4>{isEditing === true ? "Update Client" : "Add Client"}</h4>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Client Name : <span class="requiredAstric"> *</span></label>
                                            <input type="text"  {...register("name", { required: true })} className="border mb-2" placeholder="title" aria-invalid={errors.name ? "true" : "false"} />
                                            {errors.name?.type === 'required' && <p className="text-danger" role="alert">name is required</p>}
                                        </div>
                                        <div className="col-md-12 d-flex">
                                            <div className="col-md-6">
                                                <label>File : {isEditing === true ? <span class="requiredAstric"> *</span> : ''}</label>
                                                <input type="file"  {...register('file', { required: false })} className="border mb-2 w-100 is-invalid" onClick={() => { setBannerImage(null); }} onChange={() => { }} />
                                            </div>
                                            <div className="col-md-6 text-end">
                                                {
                                                    isEditing === true && bannerImage !== null ?
                                                        <><img src={bannerImage} width="100" height="100" /></> : <p className="mt-5">No image uploaded</p>
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <label>Description : <span class="requiredAstric"> *</span></label>
                                            <Editor className="border" placeholder="Description" 
                                                tools={[
                                                    [Bold, Italic, Underline, Strikethrough],
                                                    [Subscript, Superscript],
                                                    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                    [Indent, Outdent],
                                                    [OrderedList, UnorderedList],
                                                    FontSize,FontName,
                                                    FormatBlock,
                                                    [Undo, Redo],
                                                    [Link, Unlink, ViewHtml],
                                                    [InsertTable],
                                                    [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                    [DeleteRow, DeleteColumn, DeleteTable],
                                                    [MergeCells, SplitCell],
                                                ]}
                                                ref={editor}
                                                defaultContent={contentData}
                                                onChange={(e) => {
                                                    const regex = /(<([^>]+)>)/gi;
                                                    const result = e.html.replace(regex, "");
                                                    if (result.length > 0)
                                                        setValue('description', e.html);
                                                    else
                                                        setValue('description', null);
                                                }}
                                            />
                                            <textarea className="border d-none" {...register("description", { required: true })} placeholder="description" aria-invalid={errors.description ? "true" : "false"}></textarea>
                                            {errors.description?.type === 'required' && <p className="text-danger" role="alert">Description is required</p>}
                                        </div>
                                        {
                                            isEditing === true ?
                                                <input type="hidden" {...register('clientId')} />
                                                : null
                                        }
                                        <div className="col-md-12 d-flex justify-content-end mt-3">
                                            <div>
                                                <button className="btn btnSave mt-2">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>}

                    </div>
                </div> : ''}
            </div>
        </DashboardWrapper >
    )
}

export default ClientComponent;